import SDK from '@/components/mixins/SDK'
import AppHeader from '@/components/ui/AppHeader'

export default {
  mixins: [SDK],
  props: {
    eanupc: {
      type: String,
      default: '123456789101',
      validator: function (value) {
        let nan = isNaN(Number(value))
        return nan === false
      }
    },
    vendingFeatures: {
      type: Boolean,
      default: true
    }
  },
  components: {
    AppHeader
  },
  data () {
    return {
      product: {},
      currentIndex: 0
    }
  },

  computed: {
    variant () {
      if (this.product.variants) {
        return this.product.variants[this.currentIndex]
      }
    },
    packshot () {
      return `${this.$api.baseURL}/images/packshot/${this.variant.eanupc}.png`
    },
    texture () {
      return `${this.$api.baseURL}/images/texture/${this.variant.eanupc}.png`
    },

    finish () {
      return this.variant.finish['en-US']
    },

    name () {
      return this.product.name['en-US']
    },

    description () {
      return this.variant.shortDescription['en-US']
    },

    variant__code () {
      return this.variant.shades[0].code
    },

    variant__name () {
      return this.variant.shades[0].name['en-US']
    },
    initialIndex () {
      let index = this.eanToProduct(this.eanupc).variants.findIndex(el => {
        return el.eanupc === this.eanupc
      })
      if (index >= 0) {
        return index
      } else {
        return 0
      }
    },
    isElectron () {
      return process.env.IS_ELECTRON
    }
  },

  watch: {
    variant (to, from) {
      if (from && to.eanupc !== from.eanupc) {
        const { name } = this.$route
        if (this.$route.params.eanupc !== to.eanupc) {
          this.$router.replace({ name, params: { eanupc: to.eanupc } })
        }
      }
    }
  },

  methods: {
    back () {
      this.$router.push('/products')
    },
    toggleMode () { // improve if modiface is active & this upc is available
      this.$route.name === 'product' ? this.$router.push({
        path: `/tryon/${this.$route.params.eanupc}`
      }) : this.$router.push({
        path: `/products/${this.$route.params.eanupc}`
      })
    },
    selectedVariant (index) {
      this.currentIndex = index
    },
    payment () {
      let vouchers = !process.env.IS_ELECTRON

      if (!vouchers) {
        this.$router.push({
          path: `/dispenses/${this.product.variants[this.currentIndex].eanupc}`
        })
      } else {
        this.$router.push({
          path: `/voucher/${this.product.variants[this.currentIndex].eanupc}`
        })
      }
    },
    eanToProduct (eanupc) {
      let product = this.$store.state.Products.products.find(p => {
        let exists = false
        p.variants.forEach(v => {
          if (v.eanupc === eanupc) { exists = true }
        })
        if (exists) { return true } else {
          return false
        }
      })
      return product
    }
  },
  created () {
    this.product = this.$store.getters['Products/ean'](this.eanupc)
    for (let i = 0; i < this.product.variants.length; i++) {
      if (this.product.featuredVariant === this.product.variants[i].eanupc) {
        this.currentIndex = i
        break
      }
    }
    if (this.initialIndex !== 0) {
      this.currentIndex = this.initialIndex
    }
  }
}
